import styles from './ReviewsList.module.scss';
import { useDispatch, useSelector } from 'react-redux';
import React, { useEffect, useMemo } from 'react';
import TitleSectionBack from '../../../Common/TitleSectionBack';
import { getReviews, getReviewsStats } from '../../store/selectors';
import { reviewsActions } from '../../store';
import ReviewsTable from '../ReviewsTable';
import ReviewsStatsCard from '../ReviewsStatsCard';
import clx from 'classnames';
import useWindowSize from '../../../../utils/useWindowSize';
import { useTranslation } from 'react-i18next';
import { getActiveSalonId } from '../../../Auth/store/selectors';
const ReviewsList = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { isMobile } = useWindowSize();
  const selectSalonId = useMemo(() => getActiveSalonId(), []);
  const selectReviews = useMemo(() => getReviews(), []);
  const selectReviewsStats = useMemo(() => getReviewsStats(), []);
  const activeSalonId = useSelector(selectSalonId);
  const reviews = useSelector(selectReviews);
  const reviewsStats = useSelector(selectReviewsStats);

  useEffect(() => {
    if (activeSalonId) {
      dispatch(reviewsActions.GET_REVIEWS.REQUEST({}, null, { skipLoader: true }));
    }
  }, [dispatch, activeSalonId]);

  return (
    <div
      className={clx(styles.reviews_list_container, {
        [styles.reviews_list_container_mobile]: isMobile,
      })}
    >
      <div className={styles.header}>
        <TitleSectionBack
          title={t('reviews.list.title')}
          description={t('reviews.list.description')}
        />
      </div>
      <ReviewsStatsCard reviewsStats={reviewsStats} isMobile={isMobile} />
      <ReviewsTable
        reviews={reviews}
        reviewsStats={reviewsStats}
        isMobile={isMobile}
      />
    </div>
  );
};

export default ReviewsList;
